// ------------------------------------------------------------------------------
// Input
// author: mudas
// created: 2025/5/13
// ------------------------------------------------------------------------------

import React, { FC, ReactNode } from 'react';
import { useComputed } from 'common/hooks';

import { Input as BaseInput, InputProps, theme } from '@fuxi/eevee-ui';

export interface IProps extends InputProps {
  // input 外部的前缀内容 prefix
  outerPrefix?: ReactNode;

  // input 外部的后缀内容 suffix
  outerSuffix?: ReactNode;
}

const Input: FC<IProps> = (props) => {
  const { outerPrefix, outerSuffix, ...otherProps } = props;
  const { token } = theme.useToken();

  const column = useComputed<string>(() => {
    if (!!outerPrefix && !!outerSuffix) {
      return 'grid-cols-[max-content_1fr_max-content]';
    } else if (!!outerPrefix) {
      return 'grid-cols-[max-content_1fr]';
    } else if (!!outerSuffix) {
      return 'grid-cols-[1fr_max-content]';
    } else {
      return 'grid-cols-1';
    }
  }, [outerPrefix, outerSuffix]);

  return (
    <div className={`grid gap-2 items-center ${column}`}>
      {outerPrefix && <div style={{ color: token.Form?.labelColor }}>{outerPrefix}</div>}
      <BaseInput {...otherProps} />
      {outerSuffix && <div style={{ color: token.Form?.labelColor }}>{outerSuffix}</div>}
    </div>
  );
};

export default Input;